<template>
  <div :class="{overflow_hidden:myInHandGroup.groupStatus == '3'}" class="groupBook b_white">
    <div class="group_yhq">
      <img :src="activityDtl.coverImage" alt="">
    </div>
    <div class="group_me group_item">
      <p class="group_head mar13_b">{{ activity.title }}</p>
      <p class="f14_rem lin_15 gray_3 mar13_b">剩余{{ activityGoods.remainGoodsQuantity }}份</p>
      <p class="group_head mar13_b">活动时间</p>
      <p class="f14_rem lin_15 gray_3">
        {{ activity.startTimeStr }}
        —
        {{ activity.endTimeStr}}
      </p>
    </div>
    <div class="group_item">
      <p class="group_head mar15_b">拼团流程</p>
      <ul class="group_step clear">
        <li>
          <img src="../images/group_step1.png" alt="">
          <p>开团/参团</p>
        </li>
        <li>
          <img src="../images/group_step2.png" alt="">
          <p>分享好友</p>
          <p>邀请参团</p>
        </li>
        <li>
          <img src="../images/group_step3.png" alt="">
          <p>达到目标</p>
          <p>人数</p>
        </li>
        <li>
          <img src="../images/group_step4.png" alt="">
          <p>拼团成功</p>
          <p>等待收货</p>
        </li>
      </ul>
    </div>
    <div class="group_item group_plan_me group_plan_item relative">
      <p class="group_head mar5_b">我的拼团</p>
      <div class="group_plan_success" v-if="myInHandGroup.groupStatus && myInHandGroup.groupStatus == '2'">
        <img src="../images/group_plan_success.png" alt="">
      </div>
      <ul class="clear flex flex_wrap">
        <li>
          <div class="relative group_plan_img">
            <span class="group_plan_name">团长</span>
            <img :src="myInHandGroup.imgUrl" alt="">
          </div>
          <p class="f20_rem mui-ellipsis gray_3">{{ myInHandGroup.name }}</p>
        </li>
        <template v-if="myInHandGroup.groupDetailVoList && myInHandGroup.groupDetailVoList.length > 0">
          <li v-for="(detail, index) in myInHandGroup.groupDetailVoList" :key="index">
            <div class="relative group_plan_img">
              <img v-lazy="`${detail.imgUrl}?imageMogr2/thumbnail/120000@`">
            </div>
            <p class="f20_rem mui-ellipsis gray_3">{{ detail.name }}</p>
          </li>
        </template>
        <template v-if="myInHandGroup.remainPeople > 0">
          <li v-for="(index) in myInHandGroup.remainPeople" :key="index" @click="toShare">
            <img class="group_invite_icon" src="../images/group_invite_icon.png" alt="">
            <div class="relative group_plan_img">
              <img src="../images/group_invite.png" alt="">
            </div>
            <p class="f20_rem mui-ellipsis gray_3">拼团</p>
          </li>
        </template>
      </ul>
    </div>
    <div class="group_item group_good">
      <p class="group_head mar20_b">商品详情</p>
      <ul>
        <li class="clear" @click="toGoodsDetail(goodsEntity.goodsId)">
          <div class="collect_img relative mui-pull-left">
            <img v-lazy="`${goodsEntity.picUrl}?imageMogr2/thumbnail/120000@`">
          </div>
          <div class="mui-media-body mui-pull-left collect_main">
            <h3 class="f13_rem yahei gray_3 lin_15 mui-ellipsis-2 ">{{ goodsEntity.name }}</h3>
            <div class="box10"></div>
            <p class="red f14_rem fb">拼团价：¥ {{ activityGoods.goodsPrice }}</p>
            <div class="box5"></div>
            <p class="lin_15 f10_rem gray_6">原价：¥ {{ activityGoods.marketPrice }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="group_item group_desc" v-if="activityDtl.description">
      <p class="group_head mar20_b">活动规则</p>
      <div v-html="activityDtl.description"> </div>
    </div>
    <!--v-if="isShowBtn"-->
    <div class="box30" v-if="isIos"></div>
    <div class="box70" v-if="isShowBtn"></div>
    <div class="group_btn mar20_t" v-if="isShowBtn">
      <p class="t_center f14_rem white btn_join" @click="toOrderSubmit">我要开团¥ {{ activityGoods.sponsorPrice }}</p>
    </div>
    <div class="mask_block" v-if="myInHandGroup.groupStatus == '3'"></div>
    <div class="group_pop" v-if="isGroupFailCoupon">
      <div class="group_yhq_pop">
        <div class="group_yhq_main">
          <div class="t_center">
            <p class="white f15_rem">
              ￥<span class="f26_rem mar5_r">{{shopCoupon.regVal}}</span> <span class="f10_rem">满{{shopCoupon.regKey}}</span>
            </p>
            <p class="c_eac9ff f10_rem">{{shopCoupon.useStartTimeStr.slice(0,10)}}-{{shopCoupon.useEndTimeStr.slice(0,10)}}</p>
          </div>
          <div class="t_center w65">
            <p class="c_eac9ff f12_rem">{{getTypeName(shopCoupon)}}</p>
          </div>
        </div>
        <div class="t_center">
          <p class="f14_rem gray_3 lin_20"> 抱歉，您此次拼团失败</p>
          <p class="f14_rem gray_3 lin_20">您的金额已全额退还至您的支付账户</p>
          <p class="f14_rem gray_3 lin_20">为了感谢您的参与</p>
          <p class="f14_rem gray_3 lin_20">系统赠送您一张优惠券</p>
        </div>
        <div class="box20"></div>
        <div class="group_pop_btn white pop_btn_yhq f16_rem" @click="getCouponTo(shopCoupon)">立即使用</div>
        <div class="box15"></div>
        <div class="group_pop_btn pop_btn_yhq_join f16_rem" @click="toGoodList">好的，我要开团</div>
<!--        <div class="box15"></div>
        <p class="f15_rem t_center gray_3">不了，去<span class="c_fc4430" @click="toGoodList">首页逛逛 >> </span></p>-->
      </div>
      <!--<div class="group_pop_close t_center">-->
      <!--<img src="../images/group_pop_close.png" alt="">-->
      <!--</div>-->
    </div>
    <div class="group_pop" v-if="isGroupFail">
      <div class="group_fail">
        <div class="t_center">
          <p class="f14_rem gray_3 lin_24"> 抱歉，您此次拼团失败</p>
          <p class="f14_rem gray_3 lin_24">您的金额已全额退还至您的支付账户</p>
          <p class="f14_rem gray_3 lin_24">您可以发起新的拼团</p>
        </div>
        <div class="box40"></div>
        <div class="group_pop_btn white pop_btn_yhq f16_rem" @click="toGoodList">好的，我要开团</div>
<!--        <div class="box15"></div>
        <div class="group_pop_btn pop_btn_yhq_join f16_rem" @click="toGoodList">不了，去首页逛逛</div>-->
      </div>
      <!--<div class="group_pop_close t_center">-->
      <!--<img src="../images/group_pop_close.png" alt="">-->
      <!--</div>-->
    </div>

    <div class="group_pop" v-show="popFail">
      <div class="group_success t_center">
        <div class="box50 flex justify_end align_center direction_column">
          <p class="f16_rem gray_3 lin_24" v-html="verifyResult.msg"></p>
        </div>
        <div class="box20"></div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-if="'401100,401106'.indexOf(verifyResult.code) !== -1" @click="toGoodList">去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else-if="'401101'.indexOf(verifyResult.code) !== -1" @click="toGoodList">好的，去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else @click="popFailClose">好的</div>
      </div>
    </div>

    <div class="share_mask" v-show="isShowShare" @click="isClose">
      <img src="../images/share.png" alt="">
    </div>
    <div class="group_me_float" @click="toMyGroup">
      <img src="../images/group_me.png" alt="">
      <span>我的拼团</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .group_desc ::v-deep img {
    display: block;
    width: 100%;
  }
  @import './style.scss';
</style>

<script>
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {
  name: "groupBook",
  data() {
    return {
      popSuccess: false,
      popYhq: false,
      activity: {},
      shareBoId: "",
      activityDtl: {},
      activityGoods: {},
      myInHandGroup: {},
      goodsEntity: {},
      shopCoupon: {},
      isShowShare: false,
      popFail: false,
      verifyResult: {},
      isShowBtn: false,
      isGroupFailCoupon: false,
      isGroupFail: false,
      isIos: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true;
    }
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.queryGroupDetail();
  },
  methods: {
    queryGroupDetail() {
      this.$store.dispatch("group/goods/queryGroupDetail", {
        goodsId: this.$route.query.goodsId,
        activityId: this.$route.query.activityId,
        groupId: this.$route.query.groupId
      }).then((res) => {
        if (res.data) {
          this.activity = res.data.activity;
          this.shareBoId = res.data.shareBoId;
          this.activityDtl = res.data.activityDtl;
          this.activityGoods = res.data.activityGoods;
          this.goodsEntity = this.activityGoods.goodsEntity;
          if (res.data.shopCouponList && res.data.shopCouponList.length > 0) {
            this.shopCoupon = res.data.shopCouponList[0];//eslint-disable-line
          }
          this.getMyInHandGroupList();
          // 初始化
          this.initData();
        }
      });
    },
    getMyInHandGroupList() {
      this.$store.dispatch("group/goods/getMyInHandGroupList", {
        groupId: this.$route.query.groupId
      }).then((res) => {
        this.myInHandGroup = res.data || {};
        // 团长
        if (this.myInHandGroup.sponsorBoId && this.myInHandGroup.sponsorBoId === this.userInfo.id) {
          if (this.myInHandGroup.groupStatus === 2) {
            this.isShowBtn = true;
          }
        } else {
          this.isShowBtn = true;
        }
        // 失败 有券
        if (this.shopCoupon.id && this.myInHandGroup.groupStatus === 3) {
          $(".mask").show();
          this.isGroupFailCoupon = true;
        }
        // 失败 无券
        if (!this.shopCoupon.id && this.myInHandGroup.groupStatus === 3) {
          $(".mask").show();
          this.isGroupFail = true;
        }
      });
    },
    toGoodList() {
      this.$router.push("/group/goodList");
      this.popFailClose();
    },
    getCouponTo(coupon) {
      const {
        busType, subBusId, busId, cpChannel, cpId
      } = coupon;
      const couPonStr = `满${coupon.regKey}减${coupon.regVal}`;
      // 支持全店铺
      if (subBusId.indexOf("SHOP#FFFF") !== -1) {
        window.location.href = `${process.env.VUE_APP_APP}mob/goods/goodsList.do?shopIds=''&couPonStr=${couPonStr}`;
        return;
      }
      if (busType === "SHOP") {
        if (subBusId.split(",").length > 1) {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/goodsList.do?shopIds=${subBusId}&couPonStr=${couPonStr}`;
        } else {
          window.location.href = `${process.env.VUE_APP_APP}mob/shop/shopDetail/${subBusId}?couPonStr=${couPonStr}`;
        }
      } else if (busType === "GOODS") {
        if (cpChannel === "PLATFORM") {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/goodsList.do?platformCouponId=${cpId}&couPonStr=${couPonStr}`;
          return;
        }
        if (subBusId.split(",").length > 1) {
          window.location.href = `${process.env.VUE_APP_APP}mob/shop/shopDetail/${busId}?linkIds=${subBusId}&couPonStr=${couPonStr}`;
        } else {
          window.location.href = `${process.env.VUE_APP_APP}vm/goodDetails/${subBusId}`;
        }
      } else if (busType === "CATE") {
        window.location.href = `${process.env.VUE_APP_APP}mob/goods/goodsList.do?linkIds=${subBusId}&shopId=${busId}&couPonStr=${couPonStr}`;
      }
    },
    toOrderSubmit() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$store.dispatch("group/goods/getVerifySponsorGroup", {
        goodsId: this.activityGoods.goodsId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          const orderCartEntity = [{
            goodsId: this.activityGoods.goodsId,
            goodsQuantity: 1,
            fromShopId: this.activity.shopId,
            fundShopId: this.activity.shopId,
            fromCart: 0,
            isYxGroup: 1,
            yxGroupId: ""
          }];
          const goodsInJson = JSON.stringify(orderCartEntity);
          const carts = encodeURIComponent(goodsInJson);
          window.location.href = `${process.env.VUE_APP_APP}mob/order/confirmOrder.do?sources=0&carts=${carts}`;
          return;
        }
        if (res.code === "401108") {
          // 跳转订单详情
          this.toOrderDetail(res.data.orderId);
        } else {
          // 失败
          $(".mask").show();
          this.popFail = true;
        }
      });
    },
    toMyGroup() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$router.push(`/group/myGroup?shopId=${this.activity.shopId}`);
    },
    toOrderDetail(orderId) {
      window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderDetail.do?orderId=${orderId}`;
    },
    popFailClose() {
      $(".mask").hide();
      this.popFail = false;
    },
    isClose() {
      this.isShowShare = false;
    },
    toShare() {
      this.isShowShare = true;
    },
    initData() {
      const shareImgUrl = `${this.activityDtl.shareImage}`;
      let param = `?shopId=${this.activity.shopId}&goodsId=${this.$route.query.goodsId}&activityId=${this.$route.query.activityId}&groupId=${this.$route.query.groupId}`;
      if (this.shareBoId) {
        param = `?shareBoId=${this.shareBoId}&shopId=${this.activity.shopId}&goodsId=${this.$route.query.goodsId}&activityId=${this.$route.query.activityId}&groupId=${this.$route.query.groupId}`;
      }
      const urlShare = `${process.env.VUE_APP_APP}vm/group/shareGroupBook${param}`;
      const titleShare = `${this.activity.title}`;
      const descShare = "快来和我一起拼团吧";
      if (common.isInWeiXin()) {
        common.initShare(titleShare, descShare, urlShare, shareImgUrl);
      }
    },
    getTypeName(coupon) {
      let couponTypeName = "";
      if (!coupon || !coupon.busId) {
        return couponTypeName;
      }
      if (coupon.busId.indexOf("SHOP#FFFF") !== -1) {
        if (coupon.regVal === coupon.regKey) {
          couponTypeName = "全品类(特例商品除外)";
        } else {
          couponTypeName = "全平台通用优惠券";
        }
      } else if (coupon.busType === "SHOP") {
        couponTypeName = "全店通用";
      } else if (coupon.busType === "GOODS") {
        couponTypeName = "店铺指定商品可用";
      } else if (coupon.busType === "CATE") {
        couponTypeName = "指定分类商品可用";
      }
      return couponTypeName;
    },
    toGoodsDetail(goodsId) {
      window.location.href = `/vm/goodDetails/${goodsId}`;
    }
  }
};
</script>
